import { Outlet } from "react-router-dom";
import { IndexPageHeader, IndexPageHeaderProps } from "./IndexPageHeader";
import { memo } from "react";

interface DefaultIndexProps extends IndexPageHeaderProps {}

const DefaultIndex = memo(({ title, query, queryArgs, generalInfoPresentor, extra, tabs }: DefaultIndexProps) => {
  return (
    <div>
      <IndexPageHeader title={title} query={query} queryArgs={queryArgs} generalInfoPresentor={generalInfoPresentor} extra={extra} tabs={tabs} />
      <div className="mt-4">
        <Outlet />
      </div>
    </div>
  );
});

export const GetDefaultIndex =
  ({ title, query, queryArgs, generalInfoPresentor, extra, tabs }: DefaultIndexProps) =>
  () =>
    <DefaultIndex title={title} query={query} queryArgs={queryArgs} generalInfoPresentor={generalInfoPresentor} extra={extra} tabs={tabs} />;
